import axios from 'axios';
import React, { Component } from 'react';
import Magnifier from "react-magnifier";
import { Accordion, Button, Card, FormControl, Modal, OverlayTrigger, Popover, Tooltip } from 'react-bootstrap';
import AxiosConfig from '../../../../utilities/AxiosConfig';
import { connect } from 'react-redux'
import { AppState } from '../../../../store';
import NewInspection from './NewInspection/NewInspection'
import './VehicleInspections.css'
import snackBar from '../../../../utilities/snackBar/SnackBar';
import PhotoUploader from '../../../../utilities/uploadService/PhotoUploader';
import PortalMagnifier from '../../../../utilities/portal-magnifier/PortalMagnifier';
import reggie from '../../../../utilities/Reggie';
import dayjs from 'dayjs';

interface VehicleInspectionProps {
    details: any
    userId: string
    setWarning: Function
    inspections: Array<any>
    inspectionPics: Array<any>
    comparisonPics: Array<any>
    currentInspection: number
    currentComparison: number
    getVehicleInfo: Function
    refreshAll: Function
    openInspection: Function
    openComparison: Function
    sideMenuOpen: boolean
    showLinkPopover: boolean
}

type VehicleInspectionsTypes = {
    approved: boolean
    fullScreenPics: Array<any>
    toggleImageDisplay: boolean
    inspectionPin: boolean
    inspectionIndex: number
    comparisonPin: boolean
    comparisonIndex: number
    fullScreen: boolean
    fullScreenIndex: number
    showConfirm: boolean
    passDialogue: boolean
    failDialogue: boolean
    commentDialogue: boolean
    reviewInput: string
    zoomFactor: number
    canZoom: boolean
    newInspectionView: boolean
    addInspectionPhotoView: boolean
    newInspectionInput: string
    commentInput: string
    inspectionStatus: string
    expandLess: number
    comparisonIsOpen: boolean
}

class VehicleInspections extends Component<VehicleInspectionProps, VehicleInspectionsTypes>{

    wrapperRef: any;
    fullScreenIndex = 0

    constructor(props: any) {
        super(props)
        this.state = {
            approved: false,
            fullScreenPics: [],
            toggleImageDisplay: false,
            inspectionPin: false,
            inspectionIndex: 0,
            comparisonPin: false,
            comparisonIndex: 0,
            fullScreen: false,
            fullScreenIndex: 0,
            showConfirm: false,
            passDialogue: false,
            failDialogue: false,
            commentDialogue: false,
            inspectionStatus: "",
            reviewInput: "",
            newInspectionInput: "",
            commentInput: "",
            zoomFactor: .6,
            canZoom: false,
            newInspectionView: false,
            addInspectionPhotoView: false,
            expandLess: -1,
            comparisonIsOpen: false
        }

        this.wrapperRef = React.createRef();
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.handleKeyStroke = this.handleKeyStroke.bind(this)
        this.handleMouseWheel = this.handleMouseWheel.bind(this)
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
        document.addEventListener('keyup', this.handleKeyStroke)
        document.addEventListener('wheel', this.handleMouseWheel)
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
        document.removeEventListener('keyup', this.handleKeyStroke);
        document.removeEventListener('wheel', this.handleMouseWheel);
    }

    handleChange = (event: { target: any }) => {
        if (this.state.showConfirm) {
            this.setState({ reviewInput: event.target.value })
        }
        if (this.state.newInspectionView) {
            this.setState({ newInspectionInput: event.target.value })
        }
        if (this.state.commentDialogue) {
            this.setState({ commentInput: event.target.value })
        }
    }

    handleClickOutside = (event: { target: any }) => {
        if (this.wrapperRef.current && !this.wrapperRef.current.contains(event.target) && this.state.fullScreen) {
            this.toggleFullScreen([], 0)
        }
    }

    handleMouseWheel = (event: any) => {
        if (this.state.canZoom) {
            if (event.deltaY < 0 && this.state.zoomFactor < 2) {
                this.setState({ zoomFactor: this.state.zoomFactor + .2 })
            }
            if (event.deltaY > 0 && this.state.zoomFactor >= .8) {
                this.setState({ zoomFactor: this.state.zoomFactor - .2 })
            }
        }
    }

    handleKeyStroke = (event: { target: any, key: any }) => {
        if (!this.state.showConfirm && !this.state.newInspectionView && !this.state.commentDialogue && !this.props.showLinkPopover) {
            if ((this.state.inspectionIndex !== this.state.comparisonIndex) && (this.props.comparisonPics.length > 0) && (this.state.inspectionPin) && (this.state.comparisonPin)) {
                this.setState({ comparisonIndex: 0, inspectionIndex: 0 })
            }
            if (event.key === "ArrowRight") {
                if (!this.state.fullScreen) {
                    if ((this.state.inspectionIndex < this.props.inspectionPics.length - 1) && (this.state.comparisonIndex < this.props.comparisonPics.length - 1) && (this.state.inspectionPin) && (this.state.comparisonPin)) {
                        this.pinImage(this.state.inspectionIndex, "inspection")
                        this.pinImage(this.state.comparisonIndex, "comparison")
                        this.setState({ inspectionIndex: this.state.inspectionIndex + 1, comparisonIndex: this.state.comparisonIndex + 1 })
                    }
                    if ((this.state.inspectionIndex < this.props.inspectionPics.length - 1) && (!this.state.comparisonPin)) {
                        this.pinImage(this.state.inspectionIndex, "inspection")
                        this.setState({ inspectionIndex: this.state.inspectionIndex + 1 })
                    }
                    if ((this.state.comparisonIndex < this.props.comparisonPics.length - 1) && (!this.state.inspectionPin)) {
                        this.pinImage(this.state.comparisonIndex, "comparison")
                        this.setState({ comparisonIndex: this.state.comparisonIndex + 1 })
                    }
                }
                if (this.state.fullScreen) {
                    this.fullScreenPan("+")
                }

            }
            if (event.key === "ArrowLeft") {
                if (!this.state.fullScreen) {
                    if ((this.state.inspectionIndex > 0) && (this.state.comparisonIndex > 0) && (this.state.inspectionPin) && (this.state.comparisonPin)) {
                        this.pinImage(this.state.inspectionIndex, "inspection")
                        this.pinImage(this.state.comparisonIndex, "comparison")
                        this.setState({ inspectionIndex: this.state.inspectionIndex - 1, comparisonIndex: this.state.comparisonIndex - 1 })
                    }
                    if ((this.state.inspectionIndex > 0) && (!this.state.comparisonPin)) {
                        this.pinImage(this.state.inspectionIndex, "inspection")
                        this.setState({ inspectionIndex: this.state.inspectionIndex - 1 })
                    }
                    if ((this.state.comparisonIndex > 0) && (!this.state.inspectionPin)) {
                        this.pinImage(this.state.comparisonIndex, "comparison")
                        this.setState({ comparisonIndex: this.state.comparisonIndex - 1 })
                    }
                }
                if (this.state.fullScreen) {
                    this.fullScreenPan("-")
                }

            }
            if (event.key === "a" && this.props.inspections[this.props.currentInspection].ReviewedBy.length === 0) {
                this.openConfirmDialogue("True", this.props.inspections[this.props.currentInspection].vehicleInspectionId)
            }
            if (event.key === "r" && this.props.inspections[this.props.currentInspection].ReviewedBy.length === 0) {
                this.openConfirmDialogue("False", this.props.inspections[this.props.currentInspection].vehicleInspectionId)
            }
            if (event.key === "+") {
                this.setState({ newInspectionView: true })
            }
        }
        if (event.key === "Escape") {
            if (!this.state.fullScreen && !this.state.newInspectionView && !this.state.addInspectionPhotoView) {
                this.hidePinedImage("inspection")
                this.hidePinedImage("comparison")
            } else {
                this.toggleFullScreen([], 0)
                this.setState({ newInspectionView: false, addInspectionPhotoView: false })
            }
            this.dismissConfirmDialogue()
            this.dismissCommentDialogue()
        }
    }


    toggleZoom = (args: string) => {
        if (args === "off") {
            this.setState({ canZoom: false })
        } else {
            this.setState({ canZoom: true })
        }
    }

    toggleFullScreen = (pics: any, index: number) => {
        if (pics.length === 0) {
            this.setState({ fullScreen: false })
            // this.simulateCardClick(this.state.expandLess)
        } else {
            let temp = []
            for (let i = 0; i < pics.length; i++) {
                temp.push(pics.img)
            }
            this.setState({ fullScreen: true, fullScreenPics: pics, fullScreenIndex: index })
            snackBar({ text: "Press ESCAPE to exit", type: "plain", timeout: 1500 })
        }
    }

    toggleNewInspection = () => {
        if (this.state.newInspectionView) {
            this.setState({ newInspectionView: false })
        } else {
            this.setState({ newInspectionView: true })
        }
    }

    toggleAddNewInspectionPhoto = () => {
        if (this.state.addInspectionPhotoView) {
            this.setState({ addInspectionPhotoView: false })
        } else {
            this.setState({ addInspectionPhotoView: true })
        }
    }

    fullScreenPan = (direction: string) => {
        if (direction === '-') {
            this.fullScreenIndex -= 1
            if (this.fullScreenIndex < 0) {
                this.fullScreenIndex = this.state.fullScreenPics.length - 1
            }
        } else {
            this.fullScreenIndex += 1
            if (this.fullScreenIndex > this.state.fullScreenPics.length - 1) {
                this.fullScreenIndex = 0
            }
        }
        this.setState({ fullScreenIndex: this.fullScreenIndex })
    }

    pinImage = (index: number, type: string) => {
        if (type === "inspection") {
            if (this.props.inspectionPics.length > 0) {
                this.setState({ inspectionPin: true, inspectionIndex: index })
            }
        } else {
            if (this.props.comparisonPics.length > 0) {
                this.setState({ comparisonPin: true, comparisonIndex: index })
            }
        }
    }

    hidePinedImage = (type: string) => {
        if (type === "inspection") {
            this.setState({ inspectionPin: false })
        }
        if (type === "comparison") {
            this.setState({ comparisonPin: false })
        }
    }

    openConfirmDialogue = (pass: string, id: string) => {
        if (pass === "True") {
            this.setState({ passDialogue: true, failDialogue: false, showConfirm: true })

        } else {
            this.setState({ passDialogue: false, failDialogue: true, showConfirm: true })
        }
    }

    dismissConfirmDialogue = () => {
        this.setState({ showConfirm: false })
    }

    openCommentDialogue = (inspectionStatus: string) => {
        this.setState({ commentDialogue: true, inspectionStatus: inspectionStatus })
    }

    dismissCommentDialogue = () => {
        this.setState({ commentDialogue: false })
    }

    addComment = () => {
        let inspectionStatus = ""
        if (this.state.inspectionStatus.length > 0) {
            inspectionStatus = "False"
        } else {
            inspectionStatus = "true"
        }
        axios.get(process.env.REACT_APP_API_URL + "/api/Fleet/reviewInspection?inspectionId=" + this.props.inspections[this.props.currentInspection].vehicleInspectionId + "&reviewedById=" + this.props.userId + "&reviewedComments=" + this.state.commentInput + "&passed=" + inspectionStatus, AxiosConfig.configValue())
            .then(res => {
                this.props.getVehicleInfo()
                this.dismissConfirmDialogue()
                this.setState({ inspectionPin: false, comparisonPin: false, commentInput: "" })
            })
            .catch(err => {
                //console.log(err, err.response);
                AxiosConfig.handleError(err);
                //handle error
            })
        this.dismissCommentDialogue()
    }

    reviewInspection = (pass: string) => {
        axios.get(process.env.REACT_APP_API_URL + "/api/Fleet/reviewInspection?inspectionId=" + this.props.inspections[this.props.currentInspection].vehicleInspectionId + "&reviewedById=" + this.props.userId + "&reviewedComments=" + this.state.reviewInput + "&passed=" + pass, AxiosConfig.configValue())
            .then(res => {
                this.props.getVehicleInfo()
                this.dismissConfirmDialogue()
                this.setState({ inspectionPin: false, comparisonPin: false })
            })
            .catch(err => {
                //console.log(err, err.response);
                AxiosConfig.handleError(err);
                //handle error
            })

        let unreviewed = 0
        for (let i = 0; i < this.props.inspections.length; i++) {
            if (this.props.inspections[i].ReviewedBy === "") {
                unreviewed += 1
            }
        }
        //console.log(unreviewed)
        if (unreviewed === 1) {
            try {
                let warning: any = document.getElementById(this.props.details.VehicleNumber + "-waiting-inspection");
                warning.style.display = "none"
            } catch (error) {
                //console.log(error)
            }
        }

    }

    openComparison = (comparison: any, index: number) => {
        if (index !== this.state.expandLess) {
            this.setState({ expandLess: index })
            this.props.openComparison(comparison, index)
            this.scroll(index)
        }
        else {
            this.setState({ expandLess: -1 })
        }
    }

    scroll = (index: number) => {
        try {
            let item: any = document.getElementById("vi-toggle-" + index)
            item.scrollIntoView({ behavior: "smooth", block: "start" })
        } catch (error) {
            //console.log(error)
        }
    }

    simulateCardClick = (cardDex: number) => {
        document.getElementById("vi-toggle-" + cardDex)?.click()
    }

    formatDate = (index: number, key: "inspectionPics" | "comparisonPics") => {
        //@ts-ignore
        const date = this.props[key][index].date
        //@ts-ignore
        const offset = - this.props[key][index].offset
        return this.props.inspectionPics.length > 0 ? dayjs(date).add(offset / 60, "h").format("MM/DD/YY h:mm a") : "NA"
    }

    render() {

        let inspections = this.props.inspections

        // console.log("props: ", this.props)

        // console.log(inspections[this.props.currentInspection])

        let reviewerComments: any = []
        let inspectorComments: any = []
        if (inspections.length > 0) {
            for (let i = 0; i < inspections.length; i++) {
                let rev = inspections[i].comments.split("[Reviewer Comments:]")
                let temp = []
                for (let i = 0; i < rev.length; i++) {
                    if (i > 0) {
                        if ((rev[i].trim() !== "") && (rev[i].trim() !== "No Comments By Reviewer")) {
                            temp.push(rev[i])
                        }
                    }
                }
                reviewerComments.push(temp)
            }
            for (let i = 0; i < inspections.length; i++) {
                let ins = inspections[i].comments.split("[Reviewer Comments:]")[0]
                let temp = []
                if (ins && ins.trim() !== "") {
                    temp.push(ins)
                }
                inspectorComments.push(temp)
            }
        }

        const reviewerPopover = (
            <Popover id="popover-basic">
                <Popover.Title as="h3">Reviewer Comments</Popover.Title>
                {reviewerComments[this.props.currentInspection] &&
                    reviewerComments[this.props.currentInspection].length > 0
                    && reviewerComments[this.props.currentInspection].map((comment: string, i: number) =>
                        <Popover.Content key={"vi-reviewer-comment-" + i}>
                            {(i + 1) + ". " + comment}
                        </Popover.Content>
                    )}
            </Popover>
        )

        const inspectorPopover = (
            <Popover id="popover-basic">
                <Popover.Title as="h3">Inspector Comments</Popover.Title>
                {inspectorComments[this.props.currentInspection] &&
                    inspectorComments[this.props.currentInspection].length > 0
                    && inspectorComments[this.props.currentInspection].map((comment: string, i: number) =>
                        <Popover.Content key={"vi-reviewer-comment-" + i}>
                            {comment}
                        </Popover.Content>
                    )}
            </Popover>
        )

        const reviewerCardPopover = (index: number) => {
            return (
                <Popover id="popover-basic">
                    <Popover.Title as="h3">Reviewer Comments</Popover.Title>
                    {reviewerComments[index] &&
                        reviewerComments[index].length > 0
                        && reviewerComments[index].map((comment: string, i: number) =>
                            <Popover.Content key={"vi-reviewer-comment-" + i}>
                                {(i + 1) + ". " + comment}
                            </Popover.Content>
                        )}
                </Popover>
            )
        }

        const inspectorCardPopover = (index: number) => {
            return (
                <Popover id="popover-basic">
                    <Popover.Title as="h3">Inspector Comments</Popover.Title>
                    {inspectorComments[index] &&
                        inspectorComments[index].length > 0
                        && inspectorComments[index].map((comment: string, i: number) =>
                            <Popover.Content key={"vi-reviewer-comment-" + i}>
                                {comment}
                            </Popover.Content>
                        )}
                </Popover>
            )
        }

        const pinTooltip = (
            <Tooltip id="vi-pin-tooltip">
                Click to pin photo
            </Tooltip>
        )

        const newInspectionTooltip = (
            <Tooltip id="vi-pin-tooltip">
                Create a new inspection
            </Tooltip>
        )

        const addCommentTooltip = (
            <Tooltip id="vi-pin-tooltip">
                Add a comment
            </Tooltip>
        )

        const addNewInspectionPhotoTooltip = (
            <Tooltip id="vi-pin-tooltip">
                Add a new photo
            </Tooltip>
        )

        return (
            <div className="VehicleInspections" >
                {this.state.addInspectionPhotoView &&
                    <PhotoUploader
                        title={"New Inspection Photo"}
                        toggler={this.toggleAddNewInspectionPhoto}//your function to toggle the uploader on or off
                        photoDex={this.props.inspectionPics.length}//the length of the array of photos you adding to
                        refresher={this.props.refreshAll}
                        hashed={false}
                        multiple={true}
                        requestBody={
                            {
                                VehicleInspectionId: parseInt(inspections[this.props.currentInspection].vehicleInspectionId),
                                VehicleNumber: parseInt(this.props.details.VehicleNumber),
                                VehicleInformationId: parseInt(this.props.details.VehicleInformationId),
                                VehicleMileage: this.props.details.Mileage,
                                Latitude: 0,
                                Longitude: 0,
                                Heading: 0,
                                ClientUri: "file:///data/user/0/com.elm.elmlaunchpointmobile/cache/ExperienceData/%2540elmdev1%252FElmLaunchPointMobileApp/ImageManipulator/96740b2f-66d5-4a24-aad1-93d321657ba8.jpg",
                                ImageType: "VehicleInspection",
                                QueueStatus: "failed",
                                EmployeeId: parseInt(this.props.userId),
                                Orientation: 4,
                                EmployeeName: "",
                                EmployeeNumber: parseInt(this.props.userId),
                                Position: "Other",
                                Descriptor: "",
                            }
                        }

                    />}
                {!this.state.newInspectionView && !this.state.addInspectionPhotoView && <OverlayTrigger trigger={["hover", "focus"]} placement="auto-start" delay={0} overlay={newInspectionTooltip}>
                    <div className="NewInspectionBtn">
                        <span className="material-icons" onClick={() => this.toggleNewInspection()}>add</span>
                    </div>
                </OverlayTrigger>}
                {this.state.newInspectionView &&
                    <Modal id="fleet-photo-modal"
                        show={true}
                        backdrop="static"
                        keyboard={true}
                        size="xl"
                    >
                        <Modal.Header>
                            <Modal.Title>New Inspection</Modal.Title>
                        </Modal.Header>
                        <NewInspection
                            details={this.props.details}
                            userId={this.props.userId}
                            toggleNewInspection={this.toggleNewInspection}
                            refreshAll={this.props.refreshAll}
                        />
                    </Modal>}
                {!this.state.newInspectionView && !this.state.addInspectionPhotoView && <div>
                    {this.state.showConfirm && <Modal
                        show={true}
                        backdrop="static"
                        keyboard={true}
                    >
                        {this.state.passDialogue && <Modal.Header>
                            <Modal.Title> <span id="vi-modal-approve-inspection" className="material-icons">done</span> Approve this Inspection?</Modal.Title>
                        </Modal.Header>}
                        {!this.state.passDialogue && <Modal.Header>
                            <Modal.Title> <span id="vi-modal-reject-inspection" className="material-icons">cancel</span>Reject this Inspection?</Modal.Title>
                        </Modal.Header>}
                        <div className="VI-Modal-Input">
                            <FormControl as="textarea" rows={4}
                                placeholder={"Comments..."}
                                aria-label="Username"
                                aria-describedby="basic-addon1"
                                onChange={this.handleChange}
                                value={this.state.reviewInput}
                            />
                        </div>
                        <Modal.Footer>
                            {this.state.passDialogue && <Button variant="primary" onClick={() => this.reviewInspection("True")}>Approve</Button>}
                            {!this.state.passDialogue && <Button variant="danger" onClick={() => this.reviewInspection("False")}>Reject</Button>}
                            <Button variant="secondary" onClick={this.dismissConfirmDialogue}>Cancel</Button>
                        </Modal.Footer>
                    </Modal>}
                    {this.state.commentDialogue && <Modal
                        show={true}
                        backdrop="static"
                        keyboard={true}
                    >
                        <Modal.Header>
                            <Modal.Title> <span id="vi-modal-comment-inspection" className="material-icons">comment</span>Add Comment</Modal.Title>
                        </Modal.Header>
                        <div className="VI-Modal-Input">
                            <FormControl as="textarea" rows={4}
                                placeholder={"Comments..."}
                                aria-label="Username"
                                aria-describedby="basic-addon1"
                                onChange={this.handleChange}
                                value={this.state.commentInput}
                            />
                        </div>
                        <Modal.Footer>
                            {this.state.commentInput.length > 0 && <Button variant="primary" onClick={() => this.addComment()}>Submit</Button>}
                            <Button variant="secondary" onClick={this.dismissCommentDialogue}>Cancel</Button>
                        </Modal.Footer>
                    </Modal>}
                    {this.state.fullScreen && this.state.fullScreenPics.length > 0 && <div className="VIFullScreenCarousel">
                        <div className="VI-FullScreen-Exit-Dummy-Btn-Wrapper">
                            <span className="material-icons">close</span>
                        </div>
                        <div className="VI-Fullscreen-Img-Wrapper" ref={this.wrapperRef} onMouseEnter={() => this.toggleZoom("on")} onMouseLeave={() => this.toggleZoom("off")}>
                            <div className="VI-FullScreen-Pan-Left" onClick={() => this.fullScreenPan("-")}>
                                <span className="material-icons">keyboard_arrow_left</span>
                            </div>
                            {/*!!r-18-bk*/}
                            {/*@ts-ignore*/}
                            <Magnifier src={this.state.fullScreenPics[this.state.fullScreenIndex].img} mgWidth={200} mgHeight={200} zoomFactor={this.state.zoomFactor} mgShowOverflow={false} />
                            <div className="VI-FullScreen-Pan-Right" onClick={() => this.fullScreenPan("+")}>
                                <span className="material-icons">keyboard_arrow_right</span>
                            </div>
                        </div>
                    </div>}
                    {!this.state.fullScreen && <div>
                        {inspections.length > 0 && this.props.currentInspection > -1 && <div className="Current-Inspection-Wrapper">
                            <div className="VI-Header">
                                <div className="VI-Inspection-Status">
                                    {inspections[this.props.currentInspection].createdDate.length > 0 && <p>{inspections[this.props.currentInspection].createdDate.split(" ")[0]}</p>}
                                    {inspections[this.props.currentInspection].inspectorName && <p>{inspections[this.props.currentInspection].inspectorName}</p>}
                                    {inspectorComments[this.props.currentInspection] && inspectorComments[this.props.currentInspection].length > 0 && <OverlayTrigger trigger={["hover", "focus"]} placement="auto-end" overlay={inspectorPopover}>
                                        <span id="vi-comments" className="material-icons">chat</span>
                                    </OverlayTrigger>}
                                    {inspections[this.props.currentInspection].disabledDate.length === 0 && inspections[this.props.currentInspection].ReviewedBy.length > 0 && <div className="VI-Inspection-Status-Approved-Wrapper">
                                        <span className="material-icons-outlined" id="inspection-accordion-approved">done</span>
                                        <p>Approved: {inspections[this.props.currentInspection].ReviewedDate.split(" ")[0]} by {inspections[this.props.currentInspection].reviewerName} </p>
                                        {reviewerComments[this.props.currentInspection] && reviewerComments[this.props.currentInspection].length > 0 && <OverlayTrigger trigger={["hover", "focus"]} placement="auto-end" overlay={reviewerPopover}>
                                            <span id="vi-comments" className="material-icons">chat</span>
                                        </OverlayTrigger>}
                                    </div>}
                                    {inspections[this.props.currentInspection].disabledDate.length > 0 && <div className="VI-Inspection-Status-Rejected-Wrapper">
                                        <span className="material-icons-outlined" id="inspection-accordion-rejected">close</span>
                                        <p>Rejected: {inspections[this.props.currentInspection].ReviewedDate.split(" ")[0]} by {inspections[this.props.currentInspection].reviewerName} </p>
                                        {reviewerComments[this.props.currentInspection] && reviewerComments[this.props.currentInspection].length > 0 && <OverlayTrigger trigger={["hover", "focus"]} placement="auto-end" overlay={reviewerPopover}>
                                            <span id="vi-comments" className="material-icons">chat</span>
                                        </OverlayTrigger>}
                                    </div>}
                                    {inspections[this.props.currentInspection].ReviewedBy.length === 0 && <div className="VI-Inspection-Status-Waiting-Wrapper">
                                        <span className="material-icons-outlined" id="inspection-accordion-waiting">priority_high</span>
                                        <p id="vi-waiting-review-blue">Waiting Review</p>
                                    </div>}
                                    {inspections[this.props.currentInspection].ReviewedBy.length > 0 && <div className="VI-Header-btns">
                                        <OverlayTrigger trigger={["hover", "focus"]} placement="auto-end" delay={0} overlay={addCommentTooltip}>
                                            <span id="add-comment-to-review-btn" className="material-icons" onClick={() => this.openCommentDialogue(inspections[this.props.currentInspection].disabledBy)}>add_comment</span>
                                        </OverlayTrigger>
                                    </div>}
                                </div>
                                {!this.state.newInspectionView && !this.state.addInspectionPhotoView && <OverlayTrigger trigger={["hover", "focus"]} placement="auto-end" delay={0} overlay={addNewInspectionPhotoTooltip}>
                                    <div className="NewInspectionPhotoBtn">
                                        <span className="material-icons" onClick={() => this.toggleAddNewInspectionPhoto()}>add_a_photo</span>
                                    </div>
                                </OverlayTrigger>}
                                {inspections[this.props.currentInspection].ReviewedBy.length === 0 && inspections[this.props.currentInspection]?.employeeId != this.props.userId && <div className="VI-Header-Review-btns">
                                    <Button variant="Light" id="VI-header-approve-btn" onClick={() => this.openConfirmDialogue("True", inspections[this.props.currentInspection].vehicleInspectionId)}><div id="VI-header-approve"><span className="material-icons">done</span><p>Approve</p></div></Button>
                                    <Button variant="Light" id="VI-header-reject-btn" onClick={() => this.openConfirmDialogue("False", inspections[this.props.currentInspection].vehicleInspectionId)}><div id="VI-header-reject"><span className="material-icons">cancel</span><p>Reject</p></div></Button>
                                </div>}
                                <div className="VI-Header-Debug">
                                    <p>{inspections[this.props.currentInspection].vehicleInspectionId}</p>
                                </div>
                            </div>
                            {this.state.inspectionPin && this.props.inspectionPics.length > 0 && this.props.inspectionPics[this.state.inspectionIndex].img && <div className="PreviewInspectionPinWrapper">
                                <div className="PreviewInspectionPin" onMouseEnter={() => this.toggleZoom("on")} onMouseLeave={() => this.toggleZoom("off")}>
                                    <PortalMagnifier
                                        src={this.props.inspectionPics[this.state.inspectionIndex].img}
                                        id={"preview-inspection-img-pin"}
                                        mgWidth={200}
                                        mgHeight={200}
                                        mgOverflow={true}
                                    />
                                    <div id="vi-pin-footer">
                                        <p id="vi-hide-pinned-image" onClick={() => this.hidePinedImage("inspection")}>X</p>
                                        <p>{this.formatDate(this.state.inspectionIndex, "inspectionPics")}</p>
                                        <span className="material-icons" onClick={() => this.toggleFullScreen(this.props.inspectionPics, this.state.inspectionIndex)} >fullscreen</span>
                                    </div>
                                </div>
                            </div>}
                            {this.state.comparisonPin && this.props.comparisonPics.length > 0 && this.props.comparisonPics[this.state.comparisonIndex].img && <div className="ComparisonInspectionPinWrapper">
                                <div className="ComparisonInspectionPin" onMouseEnter={() => this.toggleZoom("on")} onMouseLeave={() => this.toggleZoom("off")}>
                                    <PortalMagnifier
                                        src={this.props.comparisonPics[this.state.comparisonIndex].img}
                                        id={"comparison-inspection-img-pin"}
                                        mgWidth={200}
                                        mgHeight={200}
                                        mgOverflow={true}
                                    />
                                    <div id="vi-pin-footer">
                                        <p id="vi-hide-pinned-image" onClick={() => this.hidePinedImage("comparison")}>X</p>
                                        <p>{this.formatDate(this.state.comparisonIndex, "comparisonPics")}</p>
                                        <span className="material-icons" onClick={() => this.toggleFullScreen(this.props.comparisonPics, this.state.comparisonIndex)}>fullscreen</span>
                                    </div>
                                </div>
                            </div>}
                        </div>}
                        {this.props.inspectionPics.length === 0 && <div className="VI-Carousel-No-Img">
                            <p>No Inspection Photos</p>
                            <span className="material-icons" id="vi-carousel-no-img">image_not_supported</span>
                        </div>}
                        {this.props.inspectionPics.length > 0 && <div className="VI-Carousel" key={"open-inspection-" + this.props.currentInspection}>
                            {this.props.inspectionPics.map((img: any, i: number) =>
                                <div id="vi-carousel-img" key={i} onClick={() => this.pinImage(i, "inspection")}>
                                    <OverlayTrigger trigger={["hover", "focus"]} placement="auto-start" delay={0} overlay={pinTooltip}>
                                        <img src={img.img} alt=""></img>
                                    </OverlayTrigger>
                                    <p>{reggie.deCamel(img.name)}</p>
                                </div>
                            )}
                        </div>}
                        {!this.state.fullScreen && <div className={"Vehicle-Inspections-List-Sm-Open-true"}>
                            <Accordion>
                                {inspections.length > 0 && inspections.map((inspection: any, i: number) =>
                                    <div key={i}>
                                        {this.props.currentInspection !== i && <Card key={i}>
                                            <Accordion.Toggle as={Card.Header} eventKey={i + ""} id={"vi-toggle-" + i} onClick={() => this.openComparison(inspections[i].vehicleInspectionId, i)}>
                                                <div className="VI-Header-Card">
                                                    <div className="VI-Inspection-Status-Card">
                                                        <div id="vi-inspector-card-left">
                                                            {inspections[i].createdDate.length > 0 && <p>{inspections[i].createdDate.split(" ")[0]}</p>}
                                                            {inspections[i].inspectorName && <p id="vi-inspector-card-left-p">{inspections[i].inspectorName}</p>}
                                                            {inspectorComments[i] && inspectorComments[i].length > 0 && <OverlayTrigger trigger={["hover", "focus"]} placement="auto-end" overlay={inspectorCardPopover(i)}>
                                                                <span id="vi-comments" className="material-icons">chat</span>
                                                            </OverlayTrigger>}
                                                        </div>
                                                        {inspections[i].disabledDate.length === 0 && inspections[i].ReviewedBy.length > 0 && <div className="VI-Inspection-Status-Card-Approved-Wrapper">
                                                            <span className="material-icons-outlined" id="inspection-accordion-approved">done</span>
                                                            <p>Approved: {inspections[i].ReviewedDate.split(" ")[0]} by {inspections[i].reviewerName} </p>
                                                        </div>}
                                                        {inspections[i].disabledDate.length > 0 && <div className="VI-Inspection-Status-Card-Rejected-Wrapper">
                                                            <span className="material-icons-outlined" id="inspection-accordion-rejected">close</span>
                                                            <p>Rejected: {inspections[i].ReviewedDate.split(" ")[0]} by {inspections[i].reviewerName} </p>
                                                        </div>}
                                                        {inspections[i].ReviewedBy.length === 0 && <div className="VI-Inspection-Status-Card-Waiting-Wrapper">
                                                            <span className="material-icons-outlined" id="inspection-accordion-waiting">priority_high</span>
                                                            <p>Waiting Review</p>
                                                        </div>}
                                                        {reviewerComments[i] && reviewerComments[i].length > 0 && <OverlayTrigger trigger={["hover", "focus"]} placement="auto-end" overlay={reviewerCardPopover(i)}>
                                                            <span id="vi-comments" className="material-icons reviewer-poppover-card-comments">chat</span>
                                                        </OverlayTrigger>}
                                                    </div>
                                                </div>
                                            </Accordion.Toggle>
                                            <Accordion.Collapse eventKey={i + ""}>
                                                <Card.Body>
                                                    {this.props.comparisonPics.length > 0 && <div className="VI-Carousel" key={i}>
                                                        {this.props.comparisonPics.map((img: any, i: number) =>
                                                            <div id="vi-carousel-img" key={i} onClick={() => this.pinImage(i, "comparison")}>
                                                                <img src={img.img} alt=""></img>
                                                                <p>{reggie.deCamel(img.name)}</p>
                                                            </div>
                                                        )}
                                                    </div>}
                                                    {this.props.comparisonPics.length === 0 && <div className="VI-Carousel-No-Img">
                                                        <span className="material-icons" id="ousel-no-img">image_not_supported</span>
                                                    </div>}
                                                </Card.Body>
                                            </Accordion.Collapse>
                                            <div className="Toggle-Inspection-Wrapper" onClick={() => this.props.openInspection(inspections[i].vehicleInspectionId, i)}>
                                                <span className="material-icons">visibility</span>
                                            </div>
                                            {this.state.expandLess === i && <div className="Inspection-Expand-Icon-Wrapper" onClick={() => this.simulateCardClick(i)}>
                                                <span className="material-icons">expand_less</span>
                                            </div>}
                                            {this.state.expandLess !== i && <div className="Inspection-Expand-Icon-Wrapper" onClick={() => this.simulateCardClick(i)}>
                                                <span className="material-icons">expand_more</span>
                                            </div>}
                                        </Card>}
                                    </div>
                                )}
                            </Accordion>
                        </div>}
                    </div>}
                </div>}
            </div >
        )
    }
}

const mapStateToProps = (state: AppState) => ({
    userId: state.user.userId
})

export default connect(mapStateToProps)(VehicleInspections)